'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Edit = {};

exports.__exports = Edit;
